import * as _ from "lodash";
import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface CtaEntityParams {
  label?: string;
  label_type?: string;
  url?: string;
  component?: string;
  service?: string;
}
export class CtaEntity extends BaseEntityClass {
  label?: string;
  label_type?: string;
  url?: string;
  component?: string;
  service?: string;
  constructor(params: CtaEntityParams) {
    super();
    this.type = "cta";
    this.entity_version = 3;
    this.label = params.label;
    this.label_type = params.label_type;
    this.url = params.url;
    this.component = params.component;
    this.service = params.service;
  }
}
